import { IconProp } from '@fortawesome/fontawesome-svg-core';

const legacyFontAwesomeClassToIcon: Record<string, IconProp> = {
  'fa-arrow-right': ['fas', 'arrow-right'],
  'fa-arrow-up': ['fas', 'arrow-up'],
  'fa-caret-down': ['fas', 'caret-down'],
  'fa-caret-right': ['fas', 'caret-right'],
  'fa-check': ['fas', 'check'],
  'fa-check-circle': ['fas', 'circle-check'],
  'fa-check-square': ['fas', 'square-check'],
  'fa-chevron-down': ['fas', 'chevron-down'],
  'fa-chevron-up': ['fas', 'chevron-up'],
  'fa-circle': ['fas', 'circle'],
  'fa-close': ['fas', 'xmark'],
  'fa-compress': ['fas', 'compress'],
  'fa-copy': ['fas', 'copy'],
  'fa-desktop': ['fas', 'desktop'],
  'fa-download': ['fas', 'download'],
  'fa-expand': ['fas', 'expand'],
  'fa-eye': ['fas', 'eye'],
  'fa-floppy-o': ['far', 'floppy-disk'],
  'fa-info-circle': ['fas', 'circle-info'],
  // FA4 `level-down` maps to modern `arrow-turn-down` iconName
  'fa-level-down': ['fas', 'arrow-turn-down'],
  'fa-linkedin': ['fab', 'linkedin-in'],
  'fa-map-marker': ['fas', 'location-dot'],
  'fa-plus': ['fas', 'plus'],
  'fa-question-circle': ['fas', 'circle-question'],
  'fa-remove': ['fas', 'xmark'],
  'fa-search': ['fas', 'magnifying-glass'],
  'fa-search-plus': ['fas', 'magnifying-glass-plus'],
  'fa-sort': ['fas', 'sort'],
  'fa-sort-asc': ['fas', 'sort-up'],
  'fa-sort-desc': ['fas', 'sort-down'],
  'fa-star': ['fas', 'star'],
  'fa-television': ['fas', 'tv'],
  'fa-times': ['fas', 'xmark'],
  'fa-trash': ['fas', 'trash'],
  'fa-trash-o': ['far', 'trash-can'],
  'fa-warning': ['fas', 'triangle-exclamation'],
  'fa-exclamation-triangle': ['fas', 'triangle-exclamation'],
  'fa-window-restore': ['far', 'window-restore'],
  'fa-phone': ['fas', 'phone'],
};

export function mapLegacyFontAwesomeClassToIcon(iconClass?: string): IconProp | null {
  if (!iconClass) {
    return null;
  }

  const tokens = iconClass.split(/\s+/).filter(Boolean);
  for (const token of tokens) {
    const mapped = legacyFontAwesomeClassToIcon[token];
    if (mapped) {
      return mapped;
    }
  }

  return null;
}

